import React from 'react';
import pt from 'prop-types';

function SwellColorPickerPopup({ closing, children, onAnimationEnd }) {
  /** @type {React.MutableRefObject<HTMLDivElement | null>} */
  const popupRef = React.useRef(null);

  React.useEffect(() => {
    const { current } = popupRef;

    if (!current) {
      return () => {};
    }

    current.addEventListener('animationend', onAnimationEnd);

    return () => {
      current.removeEventListener('animationend', onAnimationEnd);
    };
  }, [onAnimationEnd]);

  return (
    <div
      ref={popupRef}
      aria-hidden={closing}
      className="storefront-editor--color-scheme--picker"
    >
      {children}
    </div>
  );
}

SwellColorPickerPopup.propTypes = {
  children: pt.node,
  closing: pt.bool,
  onAnimationEnd: pt.func,
};

export default React.memo(SwellColorPickerPopup);
